export enum IntegrationName {
    FETCH = 'Fetch',
    STOREBOX = 'Storebox',
    TIMELOG = 'Timelog',
    TRAVELPERK = 'TravelPerk',
}
